module.exports = __webpack_public_path__ + "static/media/react-widgets.75e5beb2.less";